/**
 * Statuts d'une tâche
 */
export const StatutsTache = {
  EN_ATTENTE: 'EN_ATTENTE',
  TERMINE: 'TERMINE',
  ECHOUE: 'ECHOUE',
};
